import * as React from 'react';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useContactLensProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../../../types/product.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { isNoRxEntry, isRxEntryOptional } from '../../types/typeguards.js';
import { ContactLensesRxInfoModal } from '../ContactLensesRxInfoModal/ContactLensesRxInfoModal.js';
import { CLOneColPrescriptionSelector } from './components/CLOneColPrescriptionSelector/CLOneColPrescriptionSelector.js';
import { CLRxableSelectContainer } from './components/CLRxableSelect/CLRxableSelectContainer.js';
import { CLTwoColPrescriptionSelector } from './components/CLTwoColPrescriptionSelector/CLTwoColPrescriptionSelector.js';
import { NoRangesConfigured } from './components/NoRangesConfigured.js';

const CLPrescriptionSelector = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant: { prescriptionRanges  } ,  } = useContactLensProductData();
    const { selectors , state , triggerToastMessage  } = useCLEcommContext();
    const { // Get the UI validation state for the prescription columns and checkboxes
    columns: { showError: showColumnsError  } , columnCheckboxes: { showError: showCheckboxesError  } , invalidSubmissionsCount , rxEntryType ,  } = state.configurator;
    const isOneColConfigurator = selectors.isOneColConfigurator(state);
    React.useEffect(()=>{
        if (showColumnsError || showCheckboxesError) {
            triggerToastMessage('prescription-form-error');
        }
    }, [
        showColumnsError,
        showCheckboxesError,
        invalidSubmissionsCount,
        triggerToastMessage
    ]);
    if (!prescriptionRanges || prescriptionRanges.length === 0) {
        return /*#__PURE__*/ React.createElement(NoRangesConfigured, null);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "cl-prescription-selector"
    }, !isNoRxEntry(rxEntryType) && /*#__PURE__*/ React.createElement(H2, {
        className: "cl-prescription-selector__title",
        variant: "heading-smallest"
    }, getLabel('products.contactLenses.prescription.title')), isRxEntryOptional(rxEntryType) && /*#__PURE__*/ React.createElement(CLRxableSelectContainer, null), isOneColConfigurator && /*#__PURE__*/ React.createElement(CLOneColPrescriptionSelector, null), !isOneColConfigurator && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLTwoColPrescriptionSelector, {
        prescriptionAttributesSet: prescriptionRanges
    }), /*#__PURE__*/ React.createElement(ContactLensesRxInfoModal, {
        className: "cl-prescription-selector__info-modal"
    })));
};

export { CLPrescriptionSelector };
//# sourceMappingURL=CLPrescriptionSelector.js.map
